<app-cosign-search
  [enableSign]="enableSign"
  (onSearch)="onSearch($event)"
  (onShowArchived)="onShowArchived($event)"
  (onClickSign)="onClickSign()"
  [selectionsCount]="selectedRowsToSign.length"
/>
<div class="billing-container overflow-y-auto">
    <thera-client-side-list 
        [columnDefs]="columnDefs" 
        [rowData]="cosignBillingData" 
        noRowsTemplate="No records found."
        (selectionChanged)="selectedForCoSign($event)" 
        [rowSelection]="'multiple'" 
        [detailRowsEnabled]="true"
        [isRowMaster]="isRowMaster" 
        [detailCellRenderer]="detailCellRenderer"
        [detailRowRenderParams]="detailCellRendererParams" 
        [suppressRowClickSelection]="true"
        [enablePagination]="showArchived"
        [isRowSelectable]="isRowSelectable" 
        [getRowId]="getRowId"
        [getRowClass]="getRowClass"
    >
    </thera-client-side-list>
</div>